var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"pt-0"},[_c('Welcome'),_c('Peruker'),_c('Instagram'),_c('Faq'),_c('Order'),_c('OmEh'),_c('Kontakt',{attrs:{"id":"kontakt"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }